<script>
  import { onMount } from 'svelte';
  import { select } from 'd3-selection';
  import { scaleLinear, scaleTime } from 'd3-scale';
  let el;
  export let data = {};
  export let chartProps = {
    height: 0,
    margins: {
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
    },
    width: 0,
  };
  export let maxVal = null;

  const draw = () => {
    const elems = data.meloni.length - 1;
    const maxY = maxVal ? maxVal : Math.max(...new Set(data.meloni.map(d => d.count)), ...new Set(data.schlein.map(d => d.count)));
    const xScale = scaleTime()
      .range([chartProps.margins.left, (chartProps.width - chartProps.margins.right)])
      .domain([new Date(data.meloni[0].published_at), new Date(data.meloni[elems].published_at)]);

    const yScale = scaleLinear()
      .range([chartProps.seriesSize, 0])
      .domain([0, maxY]);

    const container = select(el);
    container.html('');
    const svg = container.append('svg')
      .attr('width', chartProps.width)
      .attr('height', chartProps.height)
      .attr('viewbox', `0 0 ${chartProps.width} ${chartProps.height}`);
    // Headers
    const gh = svg.append('g');
    gh.append('text')
      .attr('x', chartProps.width / 2)
      .attr('y', chartProps.margins.top / 2)
      .attr('class', 'chart--header')
      .style('text-anchor', 'middle')
      .style('dominant-baseline', 'hanging')
      .style('fill', 'var(--meloni)')
      .text('Giorgia Meloni');
    gh.append('text')
      .attr('x', chartProps.width / 2)
      .attr('y', chartProps.height - chartProps.margins.bottom +  (chartProps.margins.bottom / 2))
      .attr('class', 'chart--header')
      .style('text-anchor', 'middle')
      .style('dominant-baseline', 'baseline')
      .style('fill', 'var(--schlein)')
      .text('Elly Schlein');
    
    // Axis
    const ga = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.right}, ${(chartProps.height / 2) - (chartProps.axisSize / 2)})`);

    // Meloni
    const gm = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.right}, ${chartProps.margins.top})`);
    // Schlein
    const gs = svg.append('g')
      .attr('transform', `translate(${chartProps.margins.right}, ${(chartProps.height / 2) + (chartProps.axisSize / 2)})`);
    
    data.meloni.forEach((d, i) => {
      const thisDay = new Date(d.published_at);
      const x = xScale(thisDay);
      // Axis
      let format = { day: '2-digit', month: '2-digit' };
      if (i === 0 || thisDay.getMonth() === 0) {
        format = { dateStyle: 'short' };
      }
      if (i === 0 || (i === elems && thisDay.getDate() > 10) || thisDay.getDate() === 1) {
        ga.append('line')
          .attr('class', 'axis--thick')
          .style('stroke-width', 1)
          .style('stroke', 'var(--dark)')
          .attr('x1', x)
          .attr('x2', x)
          .attr('y1', 0)
          .attr('y2', 4);

        ga.append('line')
          .attr('class', 'axis--thick')
          .style('stroke-width', 1)
          .style('stroke', 'var(--dark)')
          .attr('x1', x)
          .attr('x2', x)
          .attr('y1', chartProps.axisSize)
          .attr('y2', chartProps.axisSize - 4);

        ga.append('text')
          .attr('x', x)
          .attr('y', chartProps.axisSize / 2)
          .attr('text-anchor', ((i === 0 ? 'start' : (i === elems ? 'end' : 'middle'))))
          .attr('dominant-baseline', 'middle')
          .attr('class', 'axis--label')
          .text(new Intl.DateTimeFormat('it-IT', format).format(thisDay))
      }
      // Bars
      gm.append('rect')
        .attr('x', x)
        .attr('y', yScale(d.count))
        .attr('width', chartProps.barSize)
        .attr('height', d.count === 0 ? 1 : chartProps.seriesSize - yScale(d.count))
        .attr('class', 'bar--meloni')
        .style('fill', d.count === 0 ? 'var(--light)' : 'var(--meloni')
        .style('stroke', 'none');
    });

    data.schlein.forEach((d, i) => {
      const thisDay = new Date(d.published_at);
      const x = xScale(thisDay);
      // Bars
      gs.append('rect')
        .attr('x', x)
        .attr('y', 0)
        .attr('width', chartProps.barSize)
        .attr('height', d.count === 0 ? 1 : chartProps.seriesSize - yScale(d.count))
        .attr('class', 'bar--schlein')
        .style('fill', d.count === 0 ? 'var(--light)' : 'var(--schlein')
        .style('stroke', 'none');
    });

    // Annotations
    gm.append('line')
      .attr('x1', chartProps.margins.left)
      .attr('x2', chartProps.width - chartProps.margins.right)
      .attr('y1', yScale(maxY))
      .attr('y2', yScale(maxY))
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gm.append('text')
      .attr('x', chartProps.width - chartProps.margins.right)
      .attr('y', yScale(maxY))
      .attr('dy', 5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'hanging')
      .style('text-anchor', 'end')
      .style('fill', 'var(--notsodark)')
      .text(`${maxY} news`);
    gm.append('line')
      .attr('x1', chartProps.margins.left)
      .attr('x2', chartProps.width - chartProps.margins.right)
      .attr('y1', yScale(Math.floor(maxY / 3)))
      .attr('y2', yScale(Math.floor(maxY / 3)))
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gm.append('text')
      .attr('x', chartProps.width - chartProps.margins.right)
      .attr('y', yScale(Math.floor(maxY / 3)))
      .attr('dy', 5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'hanging')
      .style('text-anchor', 'end')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxY / 3)}`);
    gm.append('line')
      .attr('x1', chartProps.margins.left)
      .attr('x2', chartProps.width - chartProps.margins.right)
      .attr('y1', yScale(Math.floor(maxY / 3 * 2)))
      .attr('y2', yScale(Math.floor(maxY / 3 * 2)))
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gm.append('text')
      .attr('x', chartProps.width - chartProps.margins.right)
      .attr('y', yScale(Math.floor(maxY / 3 * 2)))
      .attr('dy', 5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'hanging')
      .style('text-anchor', 'end')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxY / 3 * 2)}`);
    gm.append('text')
      .attr('x', chartProps.width - chartProps.margins.right)
      .attr('y', yScale(0))
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'end')
      .style('fill', 'var(--notsodark)')
      .text(0);

    
    gs.append('line')
      .attr('x1', chartProps.margins.left)
      .attr('x2', chartProps.width - chartProps.margins.right)
      .attr('y1', chartProps.seriesSize - yScale(maxY))
      .attr('y2', chartProps.seriesSize - yScale(maxY))
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gs.append('text')
      .attr('x', chartProps.margins.left)
      .attr('y', chartProps.seriesSize - yScale(maxY))
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'start')
      .style('fill', 'var(--notsodark)')
      .text(`${maxY} news`);
    gs.append('line')
      .attr('x1', chartProps.margins.left)
      .attr('x2', chartProps.width - chartProps.margins.right)
      .attr('y1', chartProps.seriesSize - yScale(Math.floor(maxY / 3)))
      .attr('y2', chartProps.seriesSize - yScale(Math.floor(maxY / 3)))
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gs.append('text')
      .attr('x', chartProps.margins.left)
      .attr('y', chartProps.seriesSize - yScale(Math.floor(maxY / 3)))
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'start')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxY / 3)}`);
    gs.append('line')
      .attr('x1', chartProps.margins.left)
      .attr('x2', chartProps.width - chartProps.margins.right)
      .attr('y1', chartProps.seriesSize - yScale(Math.floor(maxY / 3 * 2)))
      .attr('y2', chartProps.seriesSize - yScale(Math.floor(maxY / 3 * 2)))
      .attr('class', 'line--grid')
      .style('stroke', 'var(--notsodark)')
      .style('stroke-width', 1)
      .style('stroke-dasharray', '1 3');
    gs.append('text')
      .attr('x', chartProps.margins.left)
      .attr('y', chartProps.seriesSize - yScale(Math.floor(maxY / 3 * 2)))
      .attr('dy', -5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'baseline')
      .style('text-anchor', 'start')
      .style('fill', 'var(--notsodark)')
      .text(`${Math.floor(maxY / 3 * 2)}`);
    gs.append('text')
      .attr('x', chartProps.margins.left)
      .attr('y', chartProps.seriesSize - yScale(0))
      .attr('dy', 5)
      .attr('class', 'grid--annotation')
      .style('dominant-baseline', 'hanging')
      .style('text-anchor', 'start')
      .style('fill', 'var(--notsodark)')
      .text(0);
    
  };

  $: if (chartProps.width > 0 && chartProps.height > 0) {
     draw();
  };

  onMount(() => draw());
</script>

<div class="chartHorizontal" bind:this={el} />

<style>
</style>